/*
 * Modulo compartido de popup "Quickview" (Ronson LatAm).
 * Usado por: sections/country-showcase.liquid (fichas de producto) y
 * sections/country-multicolumn.liquid (links "Conoce mas" -> Shopify Pages).
 *
 * Contrato de markup esperado:
 * - Un contenedor "root" con el atributo `data-quickview-root` y
 *   `data-modal-target="<id-del-modal>"` apuntando al id del modal asociado.
 * - Dentro del root, cualquier elemento clickeable con:
 *     data-quickview-url="<url-base-sin-query>"
 *     data-quickview-section="<handle-de-la-seccion-a-renderizar>"
 * - Un modal con esa id, conteniendo `[data-quickview-content]` (donde se
 *   inyecta el HTML) y elementos `[data-quickview-close]` para cerrarlo.
 *
 * Se apoya en la Section Rendering API de Shopify:
 * GET {{ data-quickview-url }}?section_id={{ data-quickview-section }}
 * y extrae del HTML devuelto el nodo marcado con `[data-quickview-inner]`.
 *
 * sep-2026: si ese nodo `[data-quickview-inner]` trae un atributo
 * `data-color-scheme` (ej: "color-scheme-3", ver sections/page-quickview.liquid),
 * se aplica esa clase al dialog del modal para que el popup tome el mismo
 * color de fondo que la plantilla de la pagina mostrada, en vez de quedarse
 * con el fondo blanco por defecto del modal generico.
 */
(function () {
  function openModal(modal) {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('country-quickview-lock');
  }

  function closeModal(modal, contentEl) {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('country-quickview-lock');
    if (contentEl) contentEl.innerHTML = '';
  }

  function initRoot(root) {
    if (root.dataset.quickviewWired === 'true') return;
    root.dataset.quickviewWired = 'true';

    var modalId = root.getAttribute('data-modal-target');
    var modal = modalId ? document.getElementById(modalId) : null;
    if (!modal) return;

    var contentEl = modal.querySelector('[data-quickview-content]');

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-quickview-url]');
      if (!trigger || !root.contains(trigger)) return;

      var baseUrl = trigger.getAttribute('data-quickview-url');
      var sectionHandle = trigger.getAttribute('data-quickview-section');
      if (!baseUrl || !sectionHandle) return;

      var separator = baseUrl.indexOf('?') > -1 ? '&' : '?';
      var url = baseUrl + separator + 'section_id=' + sectionHandle;

      if (contentEl) {
        contentEl.innerHTML = '<div class="country-quickview-modal__loading">Cargando...</div>';
      }
      openModal(modal);

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-quickview-inner]');
          if (contentEl) contentEl.innerHTML = inner ? inner.outerHTML : html;

          var dialog = modal.querySelector('.country-quickview-modal__dialog');
          if (dialog) {
            Array.prototype.slice.call(dialog.classList).forEach(function (cls) {
              if (/^color-scheme-/.test(cls)) dialog.classList.remove(cls);
            });
            var schemeClass = inner ? inner.getAttribute('data-color-scheme') : null;
            if (schemeClass) dialog.classList.add(schemeClass);
          }
        })
        .catch(function () {
          if (contentEl) {
            contentEl.innerHTML = '<p class="country-quickview-modal__error">No se pudo cargar el contenido.</p>';
          }
        });
    });

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-quickview-close]')) {
        closeModal(modal, contentEl);
        return;
      }
      // Soporta miniaturas (ficha de producto). No-op si el contenido no las trae.
      var thumb = event.target.closest('[data-quickview-thumb]');
      if (thumb) {
        var main = modal.querySelector('[data-quickview-main-image]');
        if (main) main.src = thumb.getAttribute('data-full-src');
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal(modal, contentEl);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-quickview-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.RonsonQuickview = window.RonsonQuickview || {};
  window.RonsonQuickview.initAll = initAll;
})();
